module.exports = __webpack_public_path__ + "media/images/word_2022-d904ec938169da52d360b01de611cd48.png";